import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Geolocation } from '@ionic-native/geolocation';
import { Platform, AlertController } from 'ionic-angular';

/*
  Generated class for the LocationProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
declare let google;
const GEOLOCATION_ERRORS = {
  'errors.location.unsupportedBrowser':
    'Browser does not support location services',
  'errors.location.permissionDenied':
    'Please allow location services to use the app',
  'errors.location.positionUnavailable':
    'Unable to determine your location, please enable location services.',
  'errors.location.timeout':
    'Unable to determine your location, please enable location services.'
};

@Injectable()
export class LocationProvider {
  public userLocation: any;
  constructor(
    public http: HttpClient,
    private geolocation: Geolocation,
    private platform: Platform,
    public alertCtrl: AlertController,
  ) {}

  getUserLocation(){
    return this.userLocation;
  }

  getLocation(showLoading: Boolean = false): Observable<any> {
    return Observable.create(observer => {
      if(this.userLocation){
        observer.next(this.userLocation);
        observer.complete();
      }
      if (this.geolocation) {
        if (!this.platform.is('cordova')) {
          // DESKTOP
          navigator.geolocation.getCurrentPosition(
            position => {
              this.userLocation = position;
              observer.next(position);
              observer.complete();
            },
            error => {
              this.handleLocationError(error);
              observer.next(null);
              observer.complete();
            }
          );
        } else {
          alert('phone')
          // PHONE
          this.geolocation
            .getCurrentPosition()
            .then(position => {
              this.userLocation = position;
              observer.next(position);
              observer.complete();
            })
            .catch(error => {
              this.handleLocationError(error);
              observer.next(null);
              observer.complete();
            });
        }
      } else {
        let alert = this.alertCtrl.create({
          title: 'Location Error',
          message: GEOLOCATION_ERRORS['errors.location.unsupportedBrowser'],
          buttons: ['OK']
        });
        alert.present();
      }
    });
  }
  getLocationByAddress(address): Observable<any> {
    return Observable.create(observer => {
      //'https://maps.googleapis.com/maps/api/geocode/xml?address=1600+Amphitheatre+Parkway';
      let geocoder = new google.maps.Geocoder();
      geocoder.geocode({ address: address }, function(results, status) {
        if (status === google.maps.GeocoderStatus.OK) {
          observer.next(results[0]);
          observer.complete();
        } else {
          observer.error(results);
        }
      });
    });
  }

  handleLocationError(error){
    let msg = null;
    switch (error.code) {
      case 1:
        msg =  GEOLOCATION_ERRORS['errors.location.permissionDenied']
        break;
      case 2:
        msg =  GEOLOCATION_ERRORS['errors.location.positionUnavailable']
        break;
      case 3:
        msg = GEOLOCATION_ERRORS['errors.location.timeout'];
        break;
    }
    if(msg){
      let alert = this.alertCtrl.create({
        title: 'Location Error',
        message: msg,
        buttons: ['OK']
      });
      alert.present();
    }
  }

  loadMap(pageMap, tasks: any[], currentUserTask: boolean, mapElement) {
    if (mapElement) {this.getLocation().subscribe(position => {
      let latLng = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
      let mapOptions = {
        center: latLng,
        zoom: 8,
        zoomControl: false,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false
      };
      
      pageMap = new google.maps.Map(mapElement.nativeElement, mapOptions);
      let bounds = new google.maps.LatLngBounds();
      let myloc = new google.maps.Marker({
        clickable: false,
        icon: new google.maps.MarkerImage(
          'assets/img/mapicons/mobile_marker.png',
          new google.maps.Size(22, 22),
          new google.maps.Point(0, 0),
          new google.maps.Point(11, 11),
          new google.maps.Size(22, 22)
        ),
        shadow: null,
        zIndex: 999,
        map: pageMap
      });


      google.maps.event.addListenerOnce(pageMap, 'idle', function() {
        //loaded fully
      });

      if(currentUserTask){
        this.getLocation().subscribe(position => {
          let me = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
          myloc.setPosition(me);
          pageMap.fitBounds(bounds);

          pageMap.setZoom(17);
        });
      }
      if(!tasks.length) return;
      this.addMarker([...tasks], bounds, pageMap, res => {
        pageMap.fitBounds(bounds);
        bounds = res.bounds
        pageMap = res.pageMap
        if(tasks.length === 1){
          pageMap.setZoom(10);
        } else {
          this.setMapBounds(tasks, pageMap)
        }
        return pageMap;
      });
    });}
  }

  addMarker(tasks, bounds, pageMap, done){
    const task = tasks[0];
    if(task){
      const latLong = {
        lat:task.address.latitude,
        lng:task.address.longitude,
      }
      let targetloc = new google.maps.Marker({
        position:latLong,
        clickable: true,
        icon: new google.maps.MarkerImage(
          'assets/img/mapicons/pin_red.svg',
          new google.maps.Size(29, 42),
          new google.maps.Point(0, 0),
          new google.maps.Point(15, 42),
          new google.maps.Size(29, 42)
        ),
        shadow: null,
        zIndex: 999,
        map: pageMap
      });

        google.maps.event.addListener(targetloc, 'click', function(e) { // 
          document.dispatchEvent(new CustomEvent("map-pin-clicked", { "detail": task.id }));
        });

        bounds.extend(latLong);
        tasks.shift();
        this.addMarker(tasks, bounds, pageMap, res => done(res))

    } else {
      done({bounds, pageMap})
    }
  }


  setMapBounds(tasks, map) {
    const bounds = new google.maps.LatLngBounds();
    if (tasks) {
      for (const task of tasks) {
        let address = task.address;
        bounds.extend(new google.maps.LatLng(address.latitude, address.longitude));
      }
    }
    map.fitBounds(bounds);

    return map;
  }
}



// WEBPACK FOOTER //
// ./src/providers/location/location.ts